{
  "translation": {
    "aboutMirador": "Projekti Mirador kohta",
    "aboutThisItem": "Teave teose kohta",
    "addedFromUrl": "(Lisatud URL-ist)",
    "addManifestUrl": "Teose asukoht",
    "addManifestUrlHelp": "IIIF manifesti URL",
    "addResource": "Lisa teos",
    "annotationCanvasLabel_1/1": "Teos: [{{label}}]",
    "annotationCanvasLabel_1/2": "Vasak: [{{label}}]",
    "annotationCanvasLabel_2/2": "Parem: [{{label}}]",
    "annotations": "Annotatsioonid",
    "attribution": "Omistus",
    "attributionTitle": "Kasutusõigused",
    "authenticationFailed": "Autentimine ebaõnnestus",
    "authenticationRequired": "Juurdepääsu saamiseks on vajalik autentimine.",
    "backToResults": "Tagasi tulemustele",
    "book": "Raamat",
    "bottom": "All",
    "cancel": "Katkesta",
    "canvasIndex": "Indeks",
    "changeTheme": "Muuda teema",
    "clearSearch": "Puhasta",
    "close": "Sulge",
    "closeAddResourceForm": "Sulge vorm",
    "closeAddResourceMenu": "Sulge teoste loend",
    "closeCompanionWindow": "Sulge paneel",
    "closeWindow": "Sulge aken",
    "collapseSection": "Sulge \"{{section}}\"",
    "collapseSidePanel": "Sulge külgpaneel",
    "collection": "Kollektsioon",
    "continue": "Jätka",
    "copy": "Kopeeri",
    "currentItem": "Kuvatav lõuend",
    "currentItem_1/1": "Pealkiri",
    "currentItem_1/2": "Vasak",
    "currentItem_2/2": "Parem",
    "dark": "Tume teema",
    "digitizedView": "Digiteeritud vaade",
    "dismiss": "Vabasta",
    "displayNoAnnotations": "Ära kuva annotatsioone",
    "downloadExport": "Ekspordi tööruum",
    "downloadExportWorkspace": "Ekspordi tööruum",
    "elastic": "Paindlik vaade",
    "elasticDescription": "Saad akende suurust muuta ja neid vabalt tööruumis ringi liigutada.",
    "emptyResourceList": "Teoste loend on tühi",
    "error": "Viga",
    "errorDialogConfirm": "OK",
    "errorDialogTitle": "Esines viga",
    "exitFullScreen": "Lähtesta",
    "expandSection": "Ava \"{{section}}\"",
    "expandSidePanel": "Ava külgpaneel",
    "exportCopied": "Tööruumi seadustused kopeeriti lõikepuhvrisse.",
    "fetchManifest": "Lisa",
    "fullScreen": "Täisekraan",
    "gallery": "Galerii",
    "hideZoomControls": "Peida suurendamisnupud",
    "highlightAllAnnotations": "Kuva kõik annotatsioonid",
    "iiif_homepage": "Teave teose kohta",
    "iiif_manifest": "IIIF manifest",
    "iiif_related": "Seotud",
    "iiif_renderings": "Alternatiivsed vormingud",
    "iiif_seeAlso": "Vaata ka",
    "import": "Impordi",
    "importWorkspace": "Impordi tööruum",
    "importWorkspaceHint": "Kleebi imporditava tööruumi seadistused.",
    "item": "Lõuend: {{label}}",
    "itemList": "Lõuendite loetelu",
    "jsError": "Tehnilised üksikasjad",
    "jsStack": "{{ stack }}",
    "language": "Keel",
    "layer_hide": "Peida kiht",
    "layer_move": "Liiguta kihti",
    "layer_opacity": "Kihi läbipaistvus",
    "layer_show": "Näita kihti",
    "layers": "Kihid",
    "light": "Hele teema",
    "links": "Lingid",
    "listAllOpenWindows": "Vali aken",
    "login": "Logi sisse",
    "logout": "Logi välja",
    "manifestError": "Ei ole võimalik lisada soovitud teost:",
    "maximizeWindow": "Suurenda akent",
    "minimizeWindow": "Vähenda akent",
    "mirador": "Mirador",
    "miradorResources": "Miradori teoste loetelu",
    "miradorViewer": "Miradori vaatur",
    "more": "rohkem...",
    "moreResults": "Veel tulemusi",
    "mosaic": "Mosaiik",
    "mosaicDescription": "Muuda töölaua akende suurust ja liiguta neid üksteise suhtes.",
    "moveCompanionWindowToBottom": "Liiguta alla",
    "moveCompanionWindowToRight": "Liiguta paremale",
    "multipartCollection": "Mitmeosaline kollektsioon",
    "nextCanvas": "Järgmine lõuend",
    "noItemSelected": "Ühtegi lõuendit pole valitud.",
    "numItems_one": "{{number}} lõuend",
    "numItems_other": "{{number}} lõuendit",
    "off": "Väljas",
    "openCompanionWindow_annotations": "Annotatsioonid",
    "openCompanionWindow_attribution": "Kasutusõigused",
    "openCompanionWindow_canvas": "Struktuur",
    "openCompanionWindow_info": "Teave",
    "openCompanionWindow_layers": "Kihid",
    "openCompanionWindow_search": "Otsing",
    "openInCompanionWindow": "Ava eraldi paneelis",
    "openWindows": "Hetkel avatud aknad",
    "pagination": "{{current}} / {{total}}",
    "position": "Asukoht",
    "previewWindowTitle": "{{title}}",
    "previousCanvas": "Eelmine lõuend",
    "related": "Seotud",
    "resource": "Teos",
    "retry": "Proovi uuesti",
    "right": "Parem",
    "rights": "Kasutuslitsents",
    "scroll": "Keri",
    "searchInputLabel": "otsinguterminid",
    "searchNextResult": "Järgmine tulemus",
    "searchNoResults": "Tulemusi ei leitud",
    "searchPreviousResult": "Eelmine tulemus",
    "searchResultsRemaining": "{{numLeft}} alles",
    "searchSubmitAria": "Otsi",
    "searchTitle": "Otsi",
    "selectWorkspaceMenu": "Vali tööruumi tüüp",
    "showCollection": "Näita kollektsiooni",
    "showingNumAnnotations_one": "Näitan {{number}} annotatsiooni",
    "showingNumAnnotations_other": "Näitan {{number}} annotatsiooni",
    "showZoomControls": "Näita suurendamisnuppe",
    "sidebarPanelsNavigation": "Külgpaneelide navigeerimine",
    "single": "Üksik",
    "startHere": "Alusta siit",
    "suggestSearch": "Otsi sellest dokumendist \"{{ query }}\"",
    "tableOfContentsList": "Sisukord",
    "theme": "Teema",
    "thumbnailList": "Pisipiltide loend",
    "thumbnailNavigation": "Pisipildid",
    "thumbnails": "Pisipildid",
    "toggleWindowSideBar": "külgpaneel",
    "totalCollections_one": "{{count}} kollektsioon",
    "totalCollections_other": "{{count}} kollektsiooni",
    "totalManifests_one": "{{count}} manifest",
    "totalManifests_other": "{{count}} manifesti",
    "tryAgain": "Proovi uuesti",
    "untitled": "[Pealkiri puudub]",
    "view": "Vaade",
    "viewWorkspaceConfiguration": "Vaata tööruumi seadistusi",
    "welcome": "Tere tulemast Miradori",
    "window": "Aken: {{label}}",
    "windowMenu": "Akna vaated ja pisipiltide kuvamine",
    "windowNavigation": "Akna navigeerimine",
    "windowPluginButtons": "Suvandid",
    "windowPluginMenu": "Akna suvandid",
    "workspace": "Tööruum",
    "workspaceFullScreen": "Täisekraan",
    "workspaceMenu": "Tööruumi sätted",
    "workspaceNavigation": "Tööruumi navigeerimine",
    "workspaceOptions": "Tööruumi valikud",
    "workspaceSelectionTitle": "Vali tööruumi tüüp",
    "zoomIn": "Suurenda sisse",
    "zoomOut": "Suurenda välja",
    "zoomReset": "Lähtesta suurendus"
  }
}
